//Padding
function wu_emergency_padding() {
  if ($('.wu-emergency').length > 0) {
    $('body').css('padding-top', $('.wu-emergency').outerHeight());
  }
}

$(document).ready(function($) {
	wu_emergency_padding();
});
$(window).resize(function(event) {
	wu_emergency_padding();
});

//Dismiss
function wu_emergency_dismiss() {
	$('.wu-emergency-closer').on('click touch', function(e){
		e.preventDefault();
		$('.wu-emergency').remove();
		$('body').removeAttr('style');

		//Set cookie
		//$.cookie('wu-emergency-dismiss', true, { expires: 7 });
	})
}

wu_emergency_dismiss();

//Hide
function wu_hide_emergency() {

	if($.cookie('wu-emergency-dismiss')) {
		$('.wu-emergency').remove();
	}
}

wu_hide_emergency();